import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import ky from "ky";
import type { HierarchyResult } from "@dealer-center/ddc-pages-dashboard-interface";

const queryKeyBase = "ddc-pages-dashboard-hirearchy";

const url = `/landing/nxlambda/dashboard/hierarchy`;

interface UseGetAccountProps {
  accountId?: string;
}

export const useGetDealerId = () => {
  const { dealer: dealerFromParams } = useParams();
  return dealerFromParams;
};
const staleTime = 600000; // 10 mins
export function useGetHirearchyData({ accountId }: UseGetAccountProps = {}) {
  const dealerFromParams = useGetDealerId();
  const accountIdToUse = accountId || dealerFromParams;

  return useQuery({
    queryKey: [queryKeyBase, { accountIdToUse }],
    enabled: !!accountIdToUse,
    queryFn: () => fetchAccountHirearchy({ accountId: accountIdToUse }),
    staleTime
  });
}

const fetchAccountHirearchy = ({ accountId }: { accountId?: string }) => {
  if (!accountId) {
    throw new Error("No accountId provided");
  }
  return ky
    .get(`${url}/${accountId}`, {
      // 2 minutes
      timeout: 120000
    })
    .json<HierarchyResult>();
};
